import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { cancellationFeesApi } from "@/redux/apis/config/trip/cancellationFees";
import { dailyHireApi } from "@/redux/apis/config/trip/dailyHire";
import { hourlyHireApi } from "@/redux/apis/config/trip/hourlyHire";
import { timeOfDayApi } from "@/redux/apis/config/trip/timeOfDay";
import { tripCostApi } from "@/redux/apis/config/trip/tripCost";
import { unscheduledStopsApi } from "@/redux/apis/config/trip/unscheduledStops";
import { ErrorResponse } from "@/redux/types";
import { initialState } from "./fixtures";
import { TripConfigState } from "./types";

export const tripReducers = (builder: ActionReducerMapBuilder<TripConfigState>) => {
  builder
    .addMatcher(tripCostApi.endpoints.getDynamicPricingStates.matchFulfilled, (state, { payload }) => {
      const { pricingStates } = payload.data;
      state.tripCost.dynamicPricing.pricingStates = pricingStates;
    })
    .addMatcher(tripCostApi.endpoints.getDynamicPricingStates.matchRejected, (state, { payload }) => {
      if (!payload?.data) return;

      const { detail } = payload.data as ErrorResponse;
      state.tripCost.errors = [...state.tripCost.errors, detail];
    })
    .addMatcher(tripCostApi.endpoints.getPricingProfiles.matchFulfilled, (state, { payload }) => {
      const { pricingProfiles, page } = payload.data;
      state.tripCost.fixedPricing.pricingProfiles = pricingProfiles;
      state.tripCost.fixedPricing.pricingProfilesPage = page;
    })
    .addMatcher(tripCostApi.endpoints.getPricingProfiles.matchRejected, (state, { payload }) => {
      if (!payload?.data) return;

      const { detail } = payload.data as ErrorResponse;
      state.tripCost.errors = [...state.tripCost.errors, detail];
    })
    .addMatcher(tripCostApi.endpoints.getPricingProfile.matchFulfilled, (state, { payload }) => {
      const pricingProfile = payload;
      state.tripCost.fixedPricing.pricingProfile = pricingProfile;
    })
    .addMatcher(tripCostApi.endpoints.getPricingProfile.matchRejected, (state, { payload }) => {
      if (!payload?.data) return;

      const { detail } = payload.data as ErrorResponse;
      state.tripCost.errors = [...state.tripCost.errors, detail];
    })
    .addMatcher(tripCostApi.endpoints.getNationwideFixedPricing.matchFulfilled, (state, { payload }) => {
      const { nationwidePricing } = payload.data;
      state.tripCost.fixedPricing.nationwidePricing = nationwidePricing;
    })
    .addMatcher(tripCostApi.endpoints.getNationwideFixedPricing.matchRejected, (state, { payload }) => {
      if (!payload?.data) return;

      const { detail } = payload.data as ErrorResponse;
      (state.tripCost.fixedPricing.nationwidePricing = initialState.tripCost.fixedPricing.nationwidePricing),
        (state.tripCost.errors = [...state.tripCost.errors, detail]);
    })
    .addMatcher(tripCostApi.endpoints.getFixedPricingStates.matchFulfilled, (state, { payload }) => {
      const { pricingStates } = payload.data;
      state.tripCost.fixedPricing.pricingStates = pricingStates;
    })
    .addMatcher(tripCostApi.endpoints.getFixedPricingStates.matchRejected, (state, { payload }) => {
      if (!payload?.data) return;

      const { detail } = payload.data as ErrorResponse;
      state.tripCost.errors = [...state.tripCost.errors, detail];
    })
    .addMatcher(tripCostApi.endpoints.getFixedPricingLocations.matchFulfilled, (state, { payload }) => {
      const { pricingLocations } = payload.data;
      state.tripCost.fixedPricing.pricingLocations = pricingLocations;
    })
    .addMatcher(tripCostApi.endpoints.getFixedPricingLocations.matchRejected, (state, { payload }) => {
      if (!payload?.data) return;

      const { detail } = payload.data as ErrorResponse;
      state.tripCost.errors = [...state.tripCost.errors, detail];
    })
    .addMatcher(timeOfDayApi.endpoints.getTimeOfDayMultipliers.matchFulfilled, (state, { payload }) => {
      const { items, page } = payload.data;
      state.timeAndDay.items = items;
      state.timeAndDay.page = page;
    })
    .addMatcher(timeOfDayApi.endpoints.getTimeOfDayMultipliers.matchRejected, (state, { payload }) => {
      if (!payload?.data) return;

      const { detail } = payload.data as ErrorResponse;
      state.timeAndDay.errors = [...state.timeAndDay.errors, detail];
    })
    .addMatcher(timeOfDayApi.endpoints.deleteTimeOfDayMultiplier.matchRejected, (state, { payload }) => {
      if (!payload?.data) return;

      const { detail } = payload.data as ErrorResponse;
      state.timeAndDay.errors = [...state.timeAndDay.errors, detail];
    })
    .addMatcher(timeOfDayApi.endpoints.reorderTimeOfDay.matchRejected, (state, { payload }) => {
      if (!payload?.data) return;

      const { detail } = payload.data as ErrorResponse;
      state.timeAndDay.errors = [...state.timeAndDay.errors, detail];
    })
    .addMatcher(cancellationFeesApi.endpoints.getAsapPricing.matchFulfilled, (state, { payload }) => {
      const { asapPricing } = payload.data;
      state.cancellationFees.asapPricing = asapPricing;
    })
    .addMatcher(cancellationFeesApi.endpoints.getAsapPricing.matchRejected, (state, { payload }) => {
      if (!payload?.data) return;

      const { detail } = payload.data as ErrorResponse;
      state.cancellationFees.errors = [...state.cancellationFees.errors, detail];
    })
    .addMatcher(cancellationFeesApi.endpoints.getStandardPricing.matchFulfilled, (state, { payload }) => {
      const { standardPricing } = payload.data;
      state.cancellationFees.standardPricing = standardPricing;
    })
    .addMatcher(cancellationFeesApi.endpoints.getStandardPricing.matchRejected, (state, { payload }) => {
      if (!payload?.data) return;

      const { detail } = payload.data as ErrorResponse;
      state.cancellationFees.errors = [...state.cancellationFees.errors, detail];
    })
    .addMatcher(hourlyHireApi.endpoints.getHourlyHire.matchFulfilled, (state, { payload }) => {
      const { pricing } = payload.data;
      state.hourlyHire.pricing = pricing;
    })
    .addMatcher(hourlyHireApi.endpoints.getHourlyHire.matchRejected, (state, { payload }) => {
      if (!payload?.data) return;

      const { detail } = payload.data as ErrorResponse;
      state.hourlyHire.errors = [...state.hourlyHire.errors, detail];
    })
    .addMatcher(hourlyHireApi.endpoints.getHourlyHireMinimum.matchFulfilled, (state, { payload }) => {
      const { minimumBookingPeriodMinutes } = payload.data;
      state.hourlyHire.minimumBookingPeriodMinutes = minimumBookingPeriodMinutes;
    })
    .addMatcher(hourlyHireApi.endpoints.getHourlyHireMinimum.matchRejected, (state, { payload }) => {
      if (!payload?.data) return;

      const { detail } = payload.data as ErrorResponse;
      state.hourlyHire.errors = [...state.hourlyHire.errors, detail];
    })
    .addMatcher(dailyHireApi.endpoints.getDailyHire.matchFulfilled, (state, { payload }) => {
      const { pricing } = payload.data;
      state.dailyHire.pricing = pricing;
    })
    .addMatcher(dailyHireApi.endpoints.getDailyHire.matchRejected, (state, { payload }) => {
      if (!payload?.data) return;

      const { detail } = payload.data as ErrorResponse;
      state.dailyHire.errors = [...state.dailyHire.errors, detail];
    })
    .addMatcher(dailyHireApi.endpoints.getDailyHireMinimum.matchFulfilled, (state, { payload }) => {
      const { minimumBookingPeriodMinutes } = payload.data;
      state.dailyHire.minimumBookingPeriodMinutes = minimumBookingPeriodMinutes;
    })
    .addMatcher(dailyHireApi.endpoints.getDailyHireMinimum.matchRejected, (state, { payload }) => {
      if (!payload?.data) return;

      const { detail } = payload.data as ErrorResponse;
      state.dailyHire.errors = [...state.dailyHire.errors, detail];
    })
    .addMatcher(unscheduledStopsApi.endpoints.getUnscheduledStops.matchFulfilled, (state, { payload }) => {
      const { details } = payload.data;
      state.unscheduledStops.details = details;
    })
    .addMatcher(unscheduledStopsApi.endpoints.getUnscheduledStops.matchRejected, (state, { payload }) => {
      if (!payload?.data) return;

      const { detail } = payload.data as ErrorResponse;
      state.unscheduledStops.errors = [...state.unscheduledStops.errors, detail];
    });
};
